<template>
  <fragment>
    <page-head
      small
      :title="local.caseRelatedProcedure.title"
      back-route-path="path"
    >
    </page-head>
    <page-content small>
      <div>
        <naj-box title="بيانات القضية">
          <naj-data-table
            no-header
            disable-items-per-page
            :headers="tableHeader"
            :loading="loading"
            :items="formModel ? [formModel] : []"
            :no-margin-bottom="false"
          ></naj-data-table>
        </naj-box>
      </div>
      <div v-if="formModel.initialDetailsData">
        <naj-box title="بيانات المحكمة المختصة">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.initialDetailsData.referredCourtId"
            :label="local.caseRelatedProcedure.courts"
            :items="allCourts"
            item-value="id"
            item-text="name"
            :disabled="true"
          ></naj-input>
        </naj-box>
      </div>
      <div>
        <v-form
          v-if="formModel"
          ref="procedureFormRef"
        >
          <div class="px-3 content-wrapper">
            <h3 class="d-inline-block primary--text font-weight-bold col col-2 mb-4">
              {{ local.attachments.title }}
            </h3>
            <template v-if="formModel.attachments!= null && formModel.attachments.length > 0">
              <naj-box
                v-for="(file,index) in formModel.attachments"
                :key="index"
                :title="file.fileName"
              >
                <v-row>
                  <v-col cols="10">
                    <label class="procedure-reason-label"> اسم المرفق</label>
                    <div>
                      <span class="procedure-reason-text">
                        {{ file.fileName }}
                      </span>
                    </div>
                  </v-col>

                  <v-col
                    class="d-flex justify-content-end align-items-center"
                    cols="2"
                  >
                    <v-btn
                      icon
                      @click="handleViewAttachment(file)"
                    >
                      <v-icon>
                        mdi-eye
                      </v-icon>
                    </v-btn>

                    <v-btn
                      v-if="!isViewMode"
                      icon
                      @click="activeAttachment = index;
                              deleteModalVisibility = true"
                    >
                      <v-icon color="red">
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </naj-box>
            </template>
            <v-row>
              <v-col
                v-if="!isViewMode "
                cols="1"
                class="mb-6"
              >
                <naj-button
                  icon="mdi-plus"
                  @click="showModal"
                >
                </naj-button>
              </v-col>
            </v-row>
            <p
              v-if="((formModel.attachments!= null&& formModel.attachments.length == 0)|| formModel.attachments == null) && submitted"
              class="title-text"
            >
              {{ local.caseRelatedProcedure.attachmentRequired }}
            </p>
          </div>

          <v-row>
            <v-col
              cols="6"
              class="text-right"
            >
              <naj-button
                outlined
                @click="$router.back()"
              >
                {{ local.caseRelatedProcedure.backToCaseFile }}
              </naj-button>
            </v-col>
            <v-col
              v-if="isEditMode"
              cols="6"
              class="text-left"
            >
              <naj-button @click="validateThenSubmit">
                {{ local.common.saveAndSend }}
              </naj-button>
              <naj-confirmation
                :show-modal="showSendProcedureConfirmationModal"
                :title="local.common.confirmationSendRequest"
                :message="local.caseRelatedProcedure.sendConfirmationMessage"
                :ok-btn-label="local.common.yes"
                :close-btn-label="local.common.no"
                @ok="onSubmit"
                @cancel="showSendProcedureConfirmationModal = false"
              ></naj-confirmation>
            </v-col>
          </v-row>

          <attachment-modal
            ref="attachmentModalComponent"
            :attachment="selectedAttachment"
            :attachment-categories="attachmentCategories"
            modal-button-text=""
            :action-text="local.attachments.addToRequest"
            :view-mode="isViewMode"
            accept="image/*,application/pdf"
            :max-file-size="5"
            @onClose="attachmentModalClosed"
            @onSubmit="submitUploadAttachment"
          ></attachment-modal>

          <acceptance-criteria-modal
            ref="acceptanceCriteriaComponent"
            :case-classification="selectedCaseClassification"
            @onSubmit="submitAcceptanceCriteriaModal"
          >
          </acceptance-criteria-modal>

          <naj-confirmation
            :show-modal="deleteModalVisibility"
            color="error"
            :title="local.common.removeConfirmation"
            :message="local.common.removeConfirmationMessage"
            :ok-btn-label="local.common.remove"
            @ok="() => {
              deleteModalVisibility = false;
              handleDeleteAttachment();
            }"
            @cancel="deleteModalVisibility = false"
          ></naj-confirmation>
        </v-form>
      </div>

      <render-attachment-modal
        :attachment-file="selectedFile"
        :modal-visibility="showViewAttachmentModal"
        @modalClose="hideViewAttachmentModal"
      >
      </render-attachment-modal>

      <naj-confirmation
        :show-modal="showValidationSummaryModal"
        :max-width="1000"
        :is-persistent="true"
        :title="`${local.caseRelatedProcedure.validationSummaryTitle}`"
        :close-btn-label="local.common.close"
        @cancel="() => {
          showValidationSummaryModal = false;
          validationSummaryText='';
        }"
      >
        <template slot="message-content">
          <v-row>
            <v-col>
              <naj-alert type="error">
                <template slot="content">
                  <div v-html="validationSummaryText" />
                </template>
              </naj-alert>
            </v-col>
          </v-row>
        </template>
      </naj-confirmation>
    </page-content>
    <incomplete-reasons
      v-if="formModel !=null && isNotCompleted"
      :request="formModel"
    ></incomplete-reasons>
  </fragment>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { mode, ProcedureStatus } from '@/helpers/enum';
import AttachmentModal from '@/components/shared/attachment-modal/index';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
const { mapActions } = createNamespacedHelpers('CasesModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
import IncompleteReasons from './incomplete-reasons/index.vue';
import AcceptanceCriteriaModal from './acceptance-criteria.vue';

export default {
  components: {
    AttachmentModal,
    RenderAttachmentModal,
    IncompleteReasons,
    AcceptanceCriteriaModal,
  },
  data() {
    return {
      path: '',
      submitted: false,
      mode,
      ProcedureStatus,
      procedure: {},
      showSendProcedureConfirmationModal: false,
      loading: false,
      tableHeader: [
        {
          value: 'caseCode',
          text: this.local.caseReply.tableHeader.caseCode,
        },
        {
          value: 'caseDate',
          text: this.local.caseReply.tableHeader.caseDate,
        },
        {
          value: 'courtName',
          text: this.local.caseReply.tableHeader.court,
        },
        {
          value: 'subCircleName',
          text: this.local.caseReply.tableHeader.circle,
        },
        {
          value: 'caseStatusName',
          text: this.local.caseReply.tableHeader.caseStatusName,
        },
        {
          value: 'caseCategoryName',
          text: this.local.caseReply.tableHeader.caseCategoryName,
        },
        {
          value: 'caseTypeName',
          text: this.local.caseReply.tableHeader.caseType,
        },
      ],
      formModel: { attachments: [] },
      selectedAttachment: null,
      deleteModalVisibility: false,
      activeAttachment: null,
      showValidationSummaryModal: false,
      validationSummaryText: '',
      showViewAttachmentModal: false,
      showAcceptanceCriteriaModal: false,

      selectedFile: {},
      selectedCaseClassification: null,
    };
  },
  computed: {
    ...mapLUTState(['attachmentCategories', 'allCourts']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNotCompleted() {
      return this.formModel && this.formModel.statusId === ProcedureStatus.inComplete;
    },

  },
  mounted() {
    this.getData();
    this.getAttachmentCategories();
  },
  methods: {
    ...mapLUTActions(['getAllCourts', 'getAttachmentCategories', 'getUserCaseClassifications']),
    ...mapActions([
      'updateCaseRelatedProcedure',
      'getCaseRelatedProcedure',
      'uploadAttachment',
      'getNonSpecialityAttachmentAcceptanceCriteria',
    ]),
    getData() {
      const objectKey = this.$route.params.requestObjectKey;
      this.loading = true;
      this.getCaseRelatedProcedure({ objectKey })
        .then(({ data }) => {
          this.procedure = {
            objectKey: data.procedureObjectKey,
            status: data.status,
            procedureDate: data.procedureDate,
          };
          this.formModel = {
            ...data,
            procedureObjectKey: this.$route.params.requestObjectKey,
          };
          this.getAllCourts();
          if (this.formModel.initialDetailsData.referredCourtId > 0) {
            const courtId = this.formModel.initialDetailsData.referredCourtId;
            const caseClassificationId = this.formModel.initialDetailsData.caseClassificationId;
            this.getNonSpecialityAttachmentAcceptanceCriteria({
              courtId,
              caseClassificationId: caseClassificationId > 0 ? caseClassificationId : 0,
            }).then((result) => {
              this.selectedCaseClassification = result.data;
            });
          }
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
    validateThenSubmit() {
      this.submitted = true;
      if (this.formModel.attachments.length > 0) {
        this.showSendProcedureConfirmationModal = true;
      }
    },
    onSubmit() {
      const payload = {
        objectKey: this.$route.params.requestObjectKey,
        data: { ...this.formModel },
      };
      this.updateCaseRelatedProcedure(payload)
        .then(() => {
          this.showSendProcedureConfirmationModal = false;
          this.toaster.success(this.local.caseRelatedProcedure.successReplyMessage);
          this.path = `/cases/case-file/true/${this.formModel.caseObjectKey}`;
          this.$router.push({ path: this.path });
        })
        .catch((err) => {
          if (err.handled) {
            this.showSendProcedureConfirmationModal = false;
            this.showValidationSummaryModal = true;
            this.validationSummaryText = err.message;
          } else {
            this.toaster.error(err.message);
          }
        })
        .finally(() => (this.loading = false));

    },
    showModal() {
      this.$refs.acceptanceCriteriaComponent.showModal();
    },
    showAttachmentModal() {
      this.$refs.attachmentModalComponent.showModal();
    },
    handleViewAttachment(file) {
      this.$set(this, 'selectedFile', {
        name: file.fileName || file.sharePointFileName,
        isImage: file.extension.startsWith('image'),
        sharePointId: file.sharePointId ?? file.sharepointId,
      });
      this.showViewAttachmentModal = true;
    },
    handleDeleteAttachment(index = this.activeAttachment) {
      this.formModel.attachments.splice(index, 1);
    },
    attachmentSelected(attachment) {
      this.selectedAttachment = attachment;

      if (attachment && this.$refs.attachmentModalComponent) {
        this.$refs.attachmentModalComponent.showModal();
      }
    },
    attachmentModalClosed() { },
    submitUploadAttachment({ attachment }) {
      if (this.formModel.attachments.find(x => x.fileName == attachment.name)) {
        this.toaster.error(this.local.caseRelatedProcedure.attachmentAlreadyExist);
        return;
      }
      this.loading = true;
      const reader = new FileReader();
      const self = this;

      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');

        self.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            caseCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            if (self.formModel.attachments == null)
              self.formModel.attachments = [];
            self.formModel.attachments.push({
              fileName: attachment.name,
              extension: attachment.extension,
              sharePointId: data,
              fileCategory: attachment.category,
            });

            this.$refs.attachmentModalComponent.closeModal();
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };

      reader.readAsDataURL(attachment.fileObject);
    },

    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },
    submitAcceptanceCriteriaModal() {
      this.$refs.acceptanceCriteriaComponent.closeModal();
      this.showAttachmentModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.head-wings {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .r-info {
    margin-left: 40px;
  }

  .not-new-mode {
    margin-left: 10px;
    margin-top: -22px;

    &::v-deep {
      .procedure-info-root {
        background-color: var(--app-light-secondary-color);
        padding: 10px 20px;
        border-radius: 5px;
        border: 1px solid var(--app-primary-color);

        > div {
          min-width: 170px;

          > b {
            display: flex;
            width: 100%;
            justify-content: space-between;
            font-weight: 700;
            margin-bottom: 5px;

            > span {
              margin-right: 0;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}

::v-deep {
  .procedure-info-root {
    background-color: var(--app-light-secondary-color);
    padding: 10px 20px;
    border-radius: 5px;
    border: 1px solid var(--app-primary-color);
    margin-bottom: 20px;

    > div {
      min-width: 170px;

      > b {
        display: flex;
        width: 100%;
        justify-content: space-between;
        font-weight: 700;
        margin-bottom: 5px;

        > span {
          margin-right: 0;
          margin-left: 5px;
        }
      }
    }
  }
}

.procedure-reason-label {
  font-size: 20px;
}
.procedure-reason-text {
  font-size: 15px;
  color: #484952a0;
}
.content-wrapper {
  border: 1px solid #e4e5e6 !important;
  margin-bottom: 25px;
}

.file-name {
  font-size: 18px;
}

.file-upload-icon {
  cursor: pointer;
}

.title-text {
  color: #a7331b;
  font: normal normal bold 18px/20px Almarai;
  margin-top: 20px;
}
</style>
